import Api from '@/services/Api'

export default {
    createBalance (form) {
      return Api().post('balance/create', form)
    },
    getAllBalance(){
        return Api().get('balance')
    }
  }
  